import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { IndentItemsDto } from './indent-items.dto';
import { indentstatusenum } from '@gtpl/shared-models/common-models';

export class IndentFormDto{
    @ApiProperty()
    @IsNotEmpty({message:"indentMaterialPreparationId Id not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    indentMaterialPreparationId: number;

    @ApiProperty()
    indentDate: Date;

    @ApiProperty()
    employeeId: number;

    @ApiProperty()
    saleOrderItemId: number;

    @ApiProperty()
    indentAgainst:string;

    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    unitId: number;
    
    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;
    
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
status:string;

@ApiProperty()
indentCode:string;
  
    @ApiProperty({type:IndentItemsDto})
    indentItemDetails:IndentItemsDto[];

}